export default __webpack_public_path__ + "static/heroHome-9d0f1f7c0fb78e5558438b16ed05c191.mp4";